import { queryClient } from '@/query-client';
import { SessionUserProvider } from '@contexts/SessionUserContext';
import { authRoutes } from '@routes/auth.routes';
import { libraryRoutes } from '@routes/library.routes';
import { workspaceRoutes } from '@routes/workspace.routes';
import { QueryClientProvider } from '@tanstack/react-query';
import App from 'antd/es/app';
import { Navigate, Outlet, createBrowserRouter } from 'react-router-dom';

import { conversationRoutes } from './conversation.routes';
import { taskRoutes } from './task.routes';

import AuthenticatedLayout from '@components/AuthenticatedLayout';
import Ping from '@components/Ping';
import StyledComponentProvider from '@components/StyledComponentProvider';
import TeamLayout from '@components/TeamLayout';
import { ThemeProvider } from '@components/ThemeProvider';
import Whoami from '@components/Whoami';
import NotFoundPage from '@pages/404';
import RootPage from '@pages/index';
import TeamHomePage from '@pages/team/[teamId]/home';
import TeamSettingsPage from '@pages/team/[teamId]/settings';
import TeamCreatePage from '@pages/team/create';

export const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <StyledComponentProvider>
            <SessionUserProvider>
              <App>
                <Whoami />
                <Ping />
                <Outlet />
              </App>
            </SessionUserProvider>
          </StyledComponentProvider>
        </QueryClientProvider>
      </ThemeProvider>
    ),
    children: [
      { path: '', element: <RootPage /> },
      authRoutes,
      {
        path: 'team',
        element: (
          <AuthenticatedLayout>
            <Outlet />
          </AuthenticatedLayout>
        ),
        children: [
          { path: 'create', element: <TeamCreatePage /> },
          ...[':teamId', ':teamId/project/:projectId'].map((path) => ({
            path,
            element: (
              <TeamLayout>
                <Outlet />
              </TeamLayout>
            ),
            children: [
              { path: '', element: <Navigate to="home" replace /> },
              { path: 'home', element: <TeamHomePage /> },
              libraryRoutes,
              { path: 'settings', element: <TeamSettingsPage /> },
              workspaceRoutes,
              conversationRoutes,
              taskRoutes,
              { path: '*', element: <NotFoundPage /> },
            ],
          })),
        ],
      },
    ],
  },
]);
